import type { ReactNode } from 'react';

// The Split-Row page toolbar (app-shell-redesign AC7): tabs on the left, filters
// and view actions on the right, one row under the stat cards. It replaces the
// old per-page header band now that the global top bar owns page chrome. Purely
// presentational — each page supplies its own tab buttons (`.sr-tab`) and right-
// side content.
//
// `tabs` is wrapped in role="tablist", so only put actual TABS in it. Rota briefly
// passed a static money summary through this slot and would have told every screen
// reader the figure was a tab; the summary was dropped instead. `left` is that
// non-tab slot (shift-alerts-who-is-on): plain content, no role, before the tabs.
export function SplitRow({ left, tabs, right }: { left?: ReactNode; tabs?: ReactNode; right?: ReactNode }) {
  return (
    <div className="split-row">
      {left && <div className="sr-left">{left}</div>}
      {tabs && (
        <div className="sr-tabs" role="tablist">
          {tabs}
        </div>
      )}
      {right && <div className="sr-right">{right}</div>}
    </div>
  );
}
